import { Plus } from "lucide-react";
import { Button } from "../ui/button";

export const MobileEventButton = ({ onClick }) => (
  <Button onClick={onClick} className="lg:hidden fixed left-4 z-30 min-h-12 max-w-[calc(100%-104px)] shadow-lg touch-manipulation"
    style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 16px)" }} data-testid="mobile-fab-new-event">
    <Plus size={18} className="mr-2 shrink-0" /> Nouvel événement
  </Button>
);